<div [ngClass]="{'study-item': true, 'selected' : selected, 'active' : active}">
	<div class="icon cp-icon-color-5">
		<cp-patient-status [statusKey]="study.statusKey" [selected]="selected" [showLabel]="false"></cp-patient-status>
		<div class="date" *ngIf="displayDate">{{ study.statusDate | cpDate: "MonthShortNameDay" }}</div>
		<div class="year" *ngIf="displayDate">{{ study.statusDate | cpDate: "YearLong" }}</div>
	</div>
	<div class="data">
		<div class="start_separator"></div>
		<div class="title">
			{{study.studyDescription}}
		</div>
		<div class="end_separator"></div>
	</div>
</div>
